import { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LangProvider, useLang } from './context/LangContext';
import { supabase } from './lib/supabase';
import AuthPage from './pages/Auth';
import ResetPasswordPage from './pages/ResetPasswordPage';
import UserApp from './pages/user/UserApp';
import BusinessApp from './pages/business/BusinessApp';
import AdminApp from './pages/admin/AdminApp';
import './i18n';

function AppRouter() {
  const { user, profile, loading } = useAuth();
  const { isRtl, lang } = useLang();
  const [recoveryMode, setRecoveryMode] = useState(false);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') setRecoveryMode(true);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (recoveryMode) return <ResetPasswordPage onDone={() => setRecoveryMode(false)} />;

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F9FAFB', fontFamily: 'Cairo, sans-serif' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>ًں—“ï¸ڈ</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#8B5CF6' }}>{isRtl ? 'ط¬ظژط¯ظˆظگظ„' : 'Jadwil'}</div>
        </div>
      </div>
    );
  }

  if (!user) return <AuthPage />;
  if (profile && profile.role === 'admin') return <AdminApp key={lang} />;
  if (profile && profile.role === 'business') return <BusinessApp key={lang} />;
  return <UserApp key={lang} />;
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </LangProvider>
  );
}


